"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoRaDevices = void 0;
const DeviceTypesEnum_1 = require("./DeviceTypesEnum");
/**
 * POC for revised DeviceTypes to address enum issue
 *
 */
const filterEnumForwardEntries = (enumObj) => {
    return Object.fromEntries(Object.entries(enumObj).filter(([key]) => isNaN(Number(key))));
};
exports.LoRaDevices = {
    ...filterEnumForwardEntries(DeviceTypesEnum_1.DeviceTypes),
    XTeL: 0x2A
};
// const x: LoRaDeviceTypeValue = 999 -> Type '999' is not assignable to type 'LoRaDeviceTypeValue'.ts(2322)
const y = 0x24; // allowed
